export default __webpack_public_path__ + "static/media/apple.2022be49.svg";